<div class="flex justify-between pl-4 mb-4">
    <h1>Policy Forms</h1>
</div>
<lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>